import { render, staticRenderFns } from "./NuevoDevolucionEmpaque.vue?vue&type=template&id=135bc418&scoped=true"
import script from "./NuevoDevolucionEmpaque.vue?vue&type=script&lang=js"
export * from "./NuevoDevolucionEmpaque.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NuevoDevolucionEmpaque.vue?vue&type=style&index=1&id=135bc418&prod&lang=css"
import style2 from "./NuevoDevolucionEmpaque.vue?vue&type=style&index=2&id=135bc418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135bc418",
  null
  
)

export default component.exports